// extracted by mini-css-extract-plugin
export default {"tbody":"DrawDetailsTable_tbody__9VURO","heading":"DrawDetailsTable_heading__W4O8H"};